import { render, staticRenderFns } from "./Ads2.vue?vue&type=template&id=4438055e&"
import script from "./Ads2.vue?vue&type=script&lang=js&"
export * from "./Ads2.vue?vue&type=script&lang=js&"
import style0 from "./Ads2.vue?vue&type=style&index=0&id=4438055e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports